var workerTimers = null;
export var createLoadWorkerTimers = function createLoadWorkerTimers(load, worker) {
  return function () {
    if (workerTimers !== null) {
      return workerTimers;
    }

    var blob = new Blob([worker], {
      type: 'application/javascript; charset=utf-8'
    });
    var url = URL.createObjectURL(blob);
    workerTimers = load(url); // Bug #1: Edge doesn't like the URL to be revoked directly.

    workerTimers.setTimeout(function () {
      return URL.revokeObjectURL(url);
    }, 0);
    return workerTimers;
  };
};